export const SET_STEP = 'SET_STEP'
export const SET_VISITED_STEP = 'SET_VISITED_STEP'
export const RESET_VISITED_STEP = 'RESET_VISITED_STEP'
export const SET_RECOMMENDATIONS = 'SET_RECOMMENDATIONS'
export const SET_RECOMMENDATION = 'SET_RECOMMENDATION'
export const RESET_RECOMMENDATION = 'RESET_RECOMMENDATION'
export const UPDATE_RECOMMENDATION = 'UPDATE_RECOMMENDATION'
export const SET_CRITERIA_CHANGED = 'SET_CRITERIA_CHANGED'
export const PREP_RECOMMENDATION = 'PREP_RECOMMENDATION'
export const RESET_TRANSLATIONS = 'RESET_TRANSLATIONS'
export const SET_TRANSLATIONS = 'SET_TRANSLATIONS'
export const RESET_RESULTTYPE = 'RESET_RESULTTYPE'
export const SET_RESULTTYPE = 'SET_RESULTTYPE'
export const SET_RESULTTYPES = 'SET_RESULTTYPES'
export const UPDATE_RESULTTYPE = 'UPDATE_RESULTTYPE'



// WEBPACK FOOTER //
// ./src/store/modules/admin/configuration/types.js